'use client';

import { ProductDisplayStyle } from '../SearchResultsGrid/types';

import { isBDSite } from '@/services/search/utils';
import type { LocaleProps } from '@nxt-costco-com/forge-digital-components';
import {
    CriteoVideoSpotlight,
    findCriteoPlacement,
    useCheckScreen,
    useCriteo,
} from '@nxt-costco-com/forge-digital-components';

export const VideoSpotlightClient = ({
    lang,
    position,
    pageType,
    product_display_style,
}: {
    lang: LocaleProps;
    position: string;
    pageType: string | undefined;
    product_display_style?: ProductDisplayStyle;
}) => {
    const { isMobile } = useCheckScreen();
    const { searchPageData } = useCriteo();

    // do not display this component above search results when the device is desktop/tablet
    if (position === 'filters' && isMobile) {
        return null;
    }

    if (position === 'grid' && !isMobile) {
        return null;
    }

    const baseKey =
        pageType === 'category'
            ? 'viewCategory'
            : isBDSite(process.env.NEXT_PUBLIC_SITE)
              ? 'viewSearchResult'
              : 'viewSearchResults';

    const videoSpotlightPlacementKey = `${baseKey}_API_${isMobile ? 'mobile' : 'desktop'}-Video`;

    const videoSpotlightPlacement = findCriteoPlacement(
        videoSpotlightPlacementKey,
        searchPageData?.placements,
    );

    const ParentSKUs =
        videoSpotlightPlacement?.products.map(
            ({ ParentSKU }: { ParentSKU: string }) => ParentSKU,
        ) || [];

    if (!videoSpotlightPlacement) {
        return null;
    } else {
        return (
            <CriteoVideoSpotlight
                contentStackEntry={{
                    criteo_placement_name: `Video`,
                    // TODO: Check and pass the appropriate values if any config needed.
                    // @ts-expect-error - product_display_style fallbacks to default values in the component
                    product_display_style,
                }}
                locale={lang}
                products={videoSpotlightPlacement?.products}
                placement={videoSpotlightPlacement}
                ParentSKUs={ParentSKUs}
                variant={'rail'}
                productTileSx={{
                    minHeight: '100%',
                    paddingRight: `2px`,
                }}
            />
        );
    }
};
